import { render, staticRenderFns } from "./PCBuilder.vue?vue&type=template&id=120a67c4&scoped=true&"
import script from "./PCBuilder.vue?vue&type=script&lang=js&"
export * from "./PCBuilder.vue?vue&type=script&lang=js&"
import style0 from "./PCBuilder.vue?vue&type=style&index=0&id=120a67c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120a67c4",
  null
  
)

export default component.exports